module.exports = __webpack_public_path__ + "img/sao.0c4c0bd6.png";